import React from 'react'
import { func, node, string, number, shape, arrayOf } from 'prop-types'

import classNames from 'src/common/helpers/class-names'
import { getPageName } from 'services/utility'

import Product from 'shared/interim/product'
import ImageStickerVolume from './image-sticker-volume'
import TitleRatingBundlePromo from './title-rating-bundle-promo'
import PriceQuantity from './price-quantity'

import './_style.scss'

import { BLOCK as blk, LINKTO } from './constants'

const Item = (props) => {
  const {
    context,
    className,
    mods: propMods,
    children,
    index,
    mix,
    item,
    categoryId,
    handleFavouriteClick,
    handleProductClick,
    commonItemUrlQueryParam,
  } = props
  const {
    cin,
    id,
    images,
    productDetails,
    quantityDetails,
    promoDetails,
    ratingAndReview,
  } = item
  const { name, isReplacement, isFavourite } = productDetails
  const { weight } = quantityDetails
  const getClassName = () => {
    const mods = [
      context === 'modal' && 'modal-ctx',
      getPageName() === 'hp' && 'home',
      ...propMods,
    ]
    const baseClass = classNames({ blk, mods })
    return `${className} ${baseClass}`
  }

  const itemUrl = `${LINKTO}/product/${id}?${commonItemUrlQueryParam}`

  const imageStickerVolumeProps = {
    cin,
    id,
    index,
    images,
    name,
    weight,
    productDetails,
    promoDetails,
    isFavourite,
    handleFavouriteClick: () => handleFavouriteClick(item),
    handleProductClick: () => handleProductClick(item),
    itemUrl,
  }

  const titleRatingBundlePromoProps = {
    name,
    isReplacement,
    promoDetails,
    ratingAndReview,
    categoryId,
    handleProductClick: () => handleProductClick(item),
    itemUrl,
  }

  const priceQuantityDataProps = {
    item,
    propMods,
  }

  return (
    <li className={`${getClassName()} ${mix}`} style={{ order: index }}>
      <Product>
        <div className={classNames({ blk, elt: 'col1', propMods })}>
          <ImageStickerVolume
            {...imageStickerVolumeProps}
            className={classNames({ blk: 'co-product', elt: 'image' })}
          />
        </div>
        <div className={classNames({ blk, elt: 'col2', propMods })}>
          <TitleRatingBundlePromo {...titleRatingBundlePromoProps} />
        </div>
        <div className={classNames({ blk, elt: 'col3', propMods })}>
          <PriceQuantity {...priceQuantityDataProps} index={index} />
        </div>
        {children}
      </Product>
    </li>
  )
}

Item.propTypes = {
  context: string,
  className: string,
  mods: arrayOf(string),
  children: node,
  index: number,
  mix: string,
  item: shape({ id: string }),
  categoryId: string,
  handleFavouriteClick: func,
  handleProductClick: func,
  commonItemUrlQueryParam: string,
}

Item.defaultProps = {
  context: '',
  className: '',
  mods: [],
  children: null,
  index: 0,
  mix: '',
  item: {},
  categoryId: '',
  handleFavouriteClick() {},
  handleProductClick() {},
  commonItemUrlQueryParam: '',
}

export default Item



// WEBPACK FOOTER //
// ./shared/interim/product-list/item/index.js